<div>
    <div class="page-title-box flex align-items-center justify-content-center">

        <div class="page-title flex justify-content-space-between align-items-center">
            <mat-card-title class="margin-0">Zip Check</mat-card-title>
        </div>
    </div>

    <div class="content-wrapper">
        <div class="flex justify-content-center">
            <mat-card>
                <mat-card-title>Zip</mat-card-title>
                <mat-divider class="mat-divider-inherit-with-margin"></mat-divider>
                <mat-card-subtitle> Please input your zip code to ensure we service your area.</mat-card-subtitle>

                <form id="zipcheckForm"
                      name="zipcheckForm"
                      #zipcheckForm="ngForm"
                      (ngSubmit)="zipcheckForm.form.valid && onZipcheckFormSubmit()"
                      novalidate>
                    <mat-form-field appearance="outline">
                        <mat-label>Zip</mat-label>
                        <input
                            id="zip"
                            name="zip"
                            type="tel"
                            matInput placeholder="98115"
                            [(ngModel)]="zipcheckData.zip"
                            (ngModelChange)="updateZip()"
                            pattern="^\d+$"
                            [minLength]="constantsService.ZIPCODE_LENGTH"
                            [maxLength]="constantsService.ZIPCODE_LENGTH"
                            #zip="ngModel"
                            (click)="eventTrackingService.clickForm('zip', component)"
                            data-cy="zip"
                            required>
                        <mat-error *ngIf="zip.invalid && zipcheckForm.submitted">
                            Please enter a valid zip
                        </mat-error>
                    </mat-form-field>

                    <div class="flex justify-content-end">
                        <button mat-flat-button
                                color="accent"
                                data-cy="checkZip"
                                type="submit">
                            Check Zip
                        </button>
                    </div>
                </form>

                <p *ngIf="showResult && zipcheckForm.submitted && zipcheckForm.valid">
                    Wrench
                    <span *ngIf="inServiceArea">does service </span>
                    <span *ngIf="!inServiceArea && !partialZip">does not service </span>
                    <span *ngIf="partialZip">partially services </span>
                    this zip.
                </p>

            </mat-card>
        </div>
    </div>
</div>

<app-full-page-spinner [hidden]="!busy">
    Checking...
</app-full-page-spinner>
